import { getCurrentInstance } from 'vue';

export function useHttp() {
  const { proxy } = getCurrentInstance();
  return proxy.$http;
}